/*
 * The single definition of "this channel is hidden".
 *
 * `hidden` arrives from the API as 0/1, but the reducers also write it from `meta.arg`
 * (hideChannel.fulfilled), so both numbers and booleans reach the store. The feature had
 * grown three spellings of the same test — `hidden === true || hidden === 1` in the search
 * filter and the reorder reducer, and plain truthiness in the toolbar count and the category
 * rail — which disagree the moment the value is anything else (a `"1"` string, or a 2).
 *
 * Disagreement is not cosmetic: the rail's Hidden row and the toolbar's visible count are
 * derived from one list and the grid's contents from another, so a mismatch shows a Hidden
 * badge of N over an empty grid.
 *
 * Truthiness is the chosen rule — it is the superset, so nothing that any previous spelling
 * treated as hidden stops being hidden.
 */
export const isChannelHidden = (channel) => !!channel?.hidden;
